module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chain"
  }, [_c('div', {
    staticClass: "banner_wrapper"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("账户信息")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-header panel-header__fix"
  }, [_c('div', {
    staticClass: "panel-select-group panel-select-group__justify"
  }, [_c('span', {
    staticClass: "panel-header__desc"
  }, [_vm._v("基本信息")]), _vm._v(" "), _c('div', {
    staticClass: "panel-header-btn",
    attrs: {
      "type": "primary",
      "plain": true
    },
    on: {
      "click": function($event) {
        _vm.changePass('chain', _vm.shop.mobile)
      }
    }
  }, [_vm._v("修改密码")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "info_wrapper"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v("商户名称")]), _vm._v(" "), _c('div', {
    staticClass: "info__sign"
  }, [_vm._v(":")]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.shop.shopname))])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v("登录账号")]), _vm._v(" "), _c('div', {
    staticClass: "info__sign"
  }, [_vm._v(":")]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.shop.mobile))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-header panel-header__fix"
  }, [_c('div', {
    staticClass: "panel-select-group"
  }, [_c('span', {
    staticClass: "panel-header__desc"
  }, [_vm._v("分店信息")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('el-button', {
    staticClass: "panel-edit-btn__subshopnum",
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.editSubShopNum($event)
      }
    }
  }, [_vm._v("编辑分店编号")]), _vm._v(" "), (!_vm.role.isBaoshang) ? _c('el-dropdown', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "hide-on-click": true
    }
  }, [_c('div', {
    staticClass: "panel-header-btn__associate"
  }, [_c('i', {
    staticClass: "icon-create"
  }), _vm._v(" "), _c('span', [_vm._v("创建分店")])]), _vm._v(" "), _c('el-dropdown-menu', {
    staticStyle: {
      "width": "155px"
    },
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        _vm.createShop($event)
      }
    }
  }, [_vm._v("直接创建")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        _vm.associate($event)
      }
    }
  }, [_vm._v("关联已有")])], 1)], 1) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "body": true
      }
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.pageShopData.list,
      "row-class-name": "el-table__row_fix"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "shop_name",
      "label": "分店名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mobile",
      "label": "登录账号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "join_time",
      "label": "注册时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.join_time))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tag",
      "label": "分店编号"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.tag))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticClass: "el-button__fix",
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.showDetail(scope)
            }
          }
        }, [_vm._v("查看详情")]), _vm._v(" "), _c('el-dropdown', [_c('span', {
          staticClass: "el-dropdown-link el-dropdown-link__fix"
        }, [_vm._v("更多"), _c('i', {
          staticClass: "el-icon-caret-bottom el-icon--right"
        })]), _vm._v(" "), _c('el-dropdown-menu', {
          staticClass: "el-dropdown-menu__fix collect",
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, [_c('el-dropdown-item', {
          staticClass: "el-dropdown-item__fix",
          nativeOn: {
            "click": function($event) {
              _vm.changePass('single', scope.row.mobile)
            }
          }
        }, [_vm._v("修改密码")]), _vm._v(" "), _c('el-dropdown-item', {
          staticClass: "el-dropdown-item__fix",
          nativeOn: {
            "click": function($event) {
              _vm.confirmDeleteShop(scope.row.uid)
            }
          }
        }, [_vm._v("删除分店")])], 1)], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), (_vm.pageShopData.count >= 10) ? _c('div', {
    staticClass: "pagination_wrapper"
  }, [_c('el-pagination', {
    ref: "page",
    attrs: {
      "layout": "total, sizes, prev, pager, next, jumper",
      "page-size": _vm.pageSize,
      "total": +_vm.pageShopData.count,
      "current-page": _vm.currentpage
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.currentChange
    }
  })], 1) : _c('div', {
    staticClass: "table_placeholder"
  })]), _vm._v(" "), _c('el-dialog', {
    staticClass: "detail_dialog",
    attrs: {
      "title": "门店详情"
    },
    model: {
      value: (_vm.isShowDetail),
      callback: function($$v) {
        _vm.isShowDetail = $$v
      },
      expression: "isShowDetail"
    }
  }, [_c('el-row', [_c('el-col', {
    staticClass: "title",
    attrs: {
      "span": 6
    }
  }, [_vm._v("登录账号")]), _vm._v(" "), _c('el-col', {
    staticClass: "desc",
    attrs: {
      "span": 10
    }
  }, [_vm._v(_vm._s(_vm.detailData.mobile))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "title",
    attrs: {
      "span": 6
    }
  }, [_vm._v("店铺名称")]), _vm._v(" "), _c('el-col', {
    staticClass: "desc",
    attrs: {
      "span": 10
    }
  }, [_vm._v(_vm._s(_vm.detailData.shopname))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "title",
    attrs: {
      "span": 6
    }
  }, [_vm._v("地址")]), _vm._v(" "), _c('el-col', {
    staticClass: "desc",
    attrs: {
      "span": 10
    }
  }, [_vm._v(_vm._s(_vm.detailData.address))])], 1), _vm._v(" "), _c('div', [_c('el-row', [_c('el-col', {
    staticClass: "title",
    attrs: {
      "span": 6
    }
  }, [_vm._v("手机号")]), _vm._v(" "), _c('el-col', {
    staticClass: "desc",
    attrs: {
      "span": 10
    }
  }, [_vm._v(_vm._s(_vm.detailData.telephone || '无'))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "title",
    attrs: {
      "span": 6
    }
  }, [_vm._v("持卡人")]), _vm._v(" "), _c('el-col', {
    staticClass: "desc",
    attrs: {
      "span": 10
    }
  }, [_vm._v(_vm._s(_vm.detailData.bankuser))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "title",
    attrs: {
      "span": 6
    }
  }, [_vm._v("银行账户")]), _vm._v(" "), _c('el-col', {
    staticClass: "desc",
    attrs: {
      "span": 10
    }
  }, [_vm._v(_vm._s(_vm.detailData.bankaccount))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "title",
    attrs: {
      "span": 6
    }
  }, [_vm._v("银行名称")]), _vm._v(" "), _c('el-col', {
    staticClass: "desc",
    attrs: {
      "span": 14
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.detailData.headbankname))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.detailData.bankname))])])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "修改密码",
      "visible": _vm.showChangePass,
      "custom-class": "mydialog",
      "top": "20%",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showChangePass = $event
      },
      "close": function($event) {
        _vm.handleClose('form')
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.formrules,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "登录账号"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.userName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "输入新密码",
      "prop": "pass"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "password",
      "placeholder": "请输入新密码"
    },
    model: {
      value: (_vm.form.pass),
      callback: function($$v) {
        _vm.$set(_vm.form, "pass", $$v)
      },
      expression: "form.pass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "确认新密码",
      "prop": "repass"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "password",
      "placeholder": "请输入确认新密码"
    },
    model: {
      value: (_vm.form.repass),
      callback: function($$v) {
        _vm.$set(_vm.form, "repass", $$v)
      },
      expression: "form.repass"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "cancel",
    on: {
      "click": function($event) {
        _vm.showChangePass = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('div', {
    staticClass: "submit",
    on: {
      "click": _vm.submit
    }
  }, [(_vm.iconShow) ? _c('span', {
    staticClass: "el-icon-loading"
  }) : _c('span', [_vm._v("确定")])])])], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "mydialog",
    attrs: {
      "title": "编辑分店编号",
      "visible": _vm.showEditSubShopNum,
      "custom-class": "mydialog_haiwai",
      "size": "small"
    },
    on: {
      "update:visible": function($event) {
        _vm.showEditSubShopNum = $event
      },
      "close": _vm.refreshSubShopData
    }
  }, [_c('el-form', {
    ref: "form-edit-subshop-num",
    staticClass: "edit-sub-tag",
    attrs: {
      "label-position": "left"
    }
  }, [_c('div', {
    staticClass: "desc",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("\n        分店编号设置成功后将会显示在下载的交易明细和交易汇总中\n      ")]), _vm._v(" "), _vm._l((_vm.shopData.list), function(shop, index) {
    return (index !== 0) ? _c('el-form-item', {
      key: index
    }, [_c('el-tooltip', {
      staticClass: "subshoptip",
      attrs: {
        "placement": "bottom",
        "content": shop.shop_name
      }
    }, [_c('label', {
      staticStyle: {
        "width": "140px"
      }
    }, [_vm._v(_vm._s(shop.shop_name))])]), _vm._v(" "), _c('el-input', {
      staticStyle: {
        "width": "65%"
      },
      attrs: {
        "size": "small",
        "placeholder": "请输入二十位以内的文字或字母"
      },
      on: {
        "blur": function($event) {
          _vm.updateShopTag(shop)
        }
      },
      model: {
        value: (shop.tag),
        callback: function($$v) {
          _vm.$set(shop, "tag", $$v)
        },
        expression: "shop.tag"
      }
    })], 1) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "submit",
    on: {
      "click": _vm.refreshSubShopData
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iconShow),
      expression: "iconShow"
    }],
    staticClass: "el-icon-loading"
  }), _vm._v("确认")])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.showDeleteShopConfirm,
      "custom-class": "mydialog pass",
      "top": "20%",
      "show-close": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showDeleteShopConfirm = $event
      },
      "close": function($event) {
        _vm.handleClose('pwdform')
      }
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_vm._v("删除分店前建议先终止该分店正在进行的会员营销活动。")]), _vm._v(" "), _c('el-form', {
    ref: "pwdform",
    attrs: {
      "model": _vm.formpwd,
      "rules": _vm.formrules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "primeaccountpwd"
    }
  }, [_c('el-input', {
    staticStyle: {
      "font-size": "12px"
    },
    attrs: {
      "placeholder": "请输入总账户登录密码",
      "type": "password"
    },
    model: {
      value: (_vm.formpwd.primeaccountpwd),
      callback: function($$v) {
        _vm.$set(_vm.formpwd, "primeaccountpwd", $$v)
      },
      expression: "formpwd.primeaccountpwd"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "submit",
    on: {
      "click": function($event) {
        _vm.checkPrimeShopPwd('pwdform', this)
      }
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iconShow),
      expression: "iconShow"
    }],
    staticClass: "el-icon-loading"
  }), _vm._v("确定")])])], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "mydialog",
    attrs: {
      "title": "关联分店",
      "visible": _vm.visible
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      },
      "close": function($event) {
        _vm.handleClose('associate_form')
      }
    }
  }, [_c('el-form', {
    ref: "associate_form",
    attrs: {
      "model": _vm.associate_form,
      "rules": _vm.formrules,
      "label-width": "80px"
    }
  }, [_c('div', {
    staticClass: "desc"
  }, [_c('p', [_vm._v("请输入您的分店信息，以做关联。")]), _vm._v(" "), _c('p', [_vm._v("如您的分店还没有账号，请联系客服或者业务员为您的分店入网。")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "分店账号",
      "prop": "account"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入分店账号"
    },
    model: {
      value: (_vm.associate_form.account),
      callback: function($$v) {
        _vm.$set(_vm.associate_form, "account", $$v)
      },
      expression: "associate_form.account"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "登录密码",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "size": "small",
      "placeholder": "请输入分店登录密码"
    },
    model: {
      value: (_vm.associate_form.password),
      callback: function($$v) {
        _vm.$set(_vm.associate_form, "password", $$v)
      },
      expression: "associate_form.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "收款人",
      "prop": "bankuser"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入分店收款人姓名"
    },
    model: {
      value: (_vm.associate_form.bankuser),
      callback: function($$v) {
        _vm.$set(_vm.associate_form, "bankuser", $$v)
      },
      expression: "associate_form.bankuser"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "银行卡号",
      "prop": "bankaccount"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入分店收款银行卡号"
    },
    model: {
      value: (_vm.associate_form.bankaccount),
      callback: function($$v) {
        _vm.$set(_vm.associate_form, "bankaccount", $$v)
      },
      expression: "associate_form.bankaccount"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "cancel",
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('div', {
    staticClass: "submit",
    on: {
      "click": _vm.submit_bind
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iconShow),
      expression: "iconShow"
    }],
    staticClass: "el-icon-loading"
  }), _vm._v("确 定")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3cd681f9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chainmanage/chainmanage.vue
// module id = 815
// module chunks = 1